import { getDoctorFunctionality, cashierIncomes, getReturns, getUnitFunctionality,getExcel} from '@/services/endpoints/reports'
import {searchReferralWays} from "@/services/endpoints/referralWays";

export default {
    async getDoctorFunctionality({commit}, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getDoctorFunctionality(payload);
            if(res.data) {
                // commit('SET_SERCHED_DRS', res.data)
                return res.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getUnitFunctionality({commit}, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await getUnitFunctionality(payload);
            if(res.data) {
                commit('SET_UNIT_TOTAL', res.data.total)
                return res.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getExcel({commit}, payload) {
        try {
            let res = await getExcel(payload);
            if(res.data) {
                const url = URL.createObjectURL(new Blob([res.data], {
                    type: 'application/vnd.ms-excel'
                }))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'unitReport_' + Math.random().toString(36).slice(2, 7));
                document.body.appendChild(link)
                link.click()
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async cashierIncomes({commit}, payload) {
        // return new Promise((resolve, reject) => {
        try {
            let res = await cashierIncomes(payload);
            if(res) {
                commit('SET_CASHIER_TOTAL', res.data.total)
                // commit('SET_SERCHED_DRS', res.data)
                return res.data
            }
        }
        catch (err) {
            
            throw new Error(err)
        }
    },
    async getReturns({commit}, payload) {
        try {
            let res = await getReturns(payload);
            if(res.data) {
                commit('SET_RETURN_TOTAL', res.data.total)
                commit('SET_RETURN_REPORT_ROWS', res.data.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async searchReferralWays({commit}, payload) {
        try {
            let res = await searchReferralWays(payload);
            if (res.data) {
                commit("SET_REFERRAL_WAYS", res.data);
                return res.data;
            }
        } catch (err) {
            
            throw new Error(err);
        }
    },

}
